import { render, staticRenderFns } from "./changeCurrency.vue?vue&type=template&id=460c4d0c"
import script from "./changeCurrency.vue?vue&type=script&lang=js"
export * from "./changeCurrency.vue?vue&type=script&lang=js"
import style0 from "./changeCurrency.vue?vue&type=style&index=0&id=460c4d0c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports